import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

import { IStoreLocatorMapProps } from './types';

const MapWrapper = Box.withConfig({
  backgroundColor: primitive.$mayoEggWhite,
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  justifyContent: 'center',
  height: {
    md: 'full',
  },
});

export const StoreLocatorMap = ({ map }: IStoreLocatorMapProps) => {
  return <MapWrapper testID="store-locator-map">{map}</MapWrapper>;
};
